import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'

export interface BroadcastPreset {
  id: string
  name: string
  emoji: string
  mode: 'text' | 'card'
  reach: 'normal' | 'max'
  message: string | null
  imageUrl: string | null
  cardTitle: string | null
  cardSubtitle: string | null
  buttons: Array<{ text: string; type?: string; value?: string }>
  isGlobal: boolean
  updatedAt: string
}

export function usePresets() {
  return useQuery<BroadcastPreset[]>({
    queryKey: ['broadcast-presets'],
    queryFn: () => api.get('/broadcast/presets'),
  })
}

export function useCreatePreset() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: Partial<BroadcastPreset>) => api.post('/broadcast/presets', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['broadcast-presets'] }),
  })
}

export function useUpdatePreset() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, ...data }: Partial<BroadcastPreset> & { id: string }) =>
      api.put(`/broadcast/presets/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['broadcast-presets'] }),
  })
}

export function useDeletePreset() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.delete(`/broadcast/presets/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['broadcast-presets'] }),
  })
}
